import * as S from "./HealthItem.style";
import { useState } from "react";
import { ModalHealthDetail } from "@/components/organisms/Modals/ModalHealthDetail";
import { ReactComponent as IconInfo } from "@/styles/assets/svg/icon_info.svg";

interface HealthItemProps {
  data?: any;
}

export const HealthItem = ({ data }: HealthItemProps) => {
  return (
    <S.HealthItem>
      <S.HealthItemTit>
        {data.data_name}
        {data.data_btn && data.data_btn}
      </S.HealthItemTit>
      {data.data.map((item: any, idx: number) => {
        return (
          <S.HealthItemContent key={idx}>
            {item.map((init: any, idx: number) => {
              return (
                <S.HealthItemData key={idx}>
                  <S.DataLabel $modal={init.modal ? true : false}>
                    <div>{init.name}</div>
                    {init.modal && <IconInfo width={18} height={18} />}
                  </S.DataLabel>

                  <S.DataValue>
                    {init.status && (
                      <S.DataStatus $status={init.status}>
                        {init.status === "warn"
                          ? "주의"
                          : init.status === "good"
                          ? "정상"
                          : "위험"}
                      </S.DataStatus>
                    )}
                    {init.data}
                  </S.DataValue>
                </S.HealthItemData>
              );
            })}
          </S.HealthItemContent>
        );
      })}
    </S.HealthItem>
  );
};

interface HealthItemTitleProps {
  title: string;
  button?: React.ReactNode;
}

export const HealthItemTitle = ({ title, button }: HealthItemTitleProps) => {
  return (
    <S.HealthItemTit>
      {title}
      {button && button}
    </S.HealthItemTit>
  );
};

interface HealthItemRowProps {
  name: string;
  subject?: string;
  data: string;
  status?: "warn" | "good" | "danger";
  modal?: boolean;
}

export const HealthItemRow = ({
  name,
  subject,
  data,
  status,
  modal,
}: HealthItemRowProps) => {
  const [modalShow, setModalShow] = useState(false);
  const [modalSubject, setModalSubject] = useState("");

  const handleModalShow = (e: any) => {
    setModalSubject(e);
    setModalShow(true);
  };
  return (
    <>
      <S.HealthItemData>
        <S.DataLabel
          $modal={modal ? true : false}
          onClick={() => modal === true && handleModalShow(subject)}
        >
          <div>{name}</div>
          {modal && <IconInfo width={18} height={18} />}
        </S.DataLabel>

        <S.DataValue>
          {status && (
            <S.DataStatus $status={status}>
              {status === "warn" ? "주의" : status === "good" ? "정상" : "위험"}
            </S.DataStatus>
          )}
          {data}
        </S.DataValue>
      </S.HealthItemData>
      {modalShow && (
        <ModalHealthDetail subject={subject} setModalShow={setModalShow} />
      )}
    </>
  );
};

interface HealthItemContentProps {
  items: Array<{
    name: string;
    data: string;
    subject?: string;
    status?: "warn" | "good" | "danger";
    modal?: boolean;
  }>;
}

export const HealthItemContent = ({ items }: HealthItemContentProps) => {
  return (
    <S.HealthItemContent>
      {items.map((item, idx) => (
        <HealthItemRow key={idx} {...item} />
      ))}
    </S.HealthItemContent>
  );
};
